import { api } from "@/lib/api";

export const PENDING_NOTE_KEY = "hm_pending_welcome_note";

export const savePendingNote = async () => {
  const note = localStorage.getItem(PENDING_NOTE_KEY);
  if (!note) return;
  try {
    await api.post("/modules/m1/complete", { note });
    localStorage.removeItem(PENDING_NOTE_KEY);
  } catch {}
};
